const makeFirstLetterCap = (data) =>
  data && data.charAt(0).toUpperCase() + data.slice(1);

export default makeFirstLetterCap;
